import gql from "graphql-tag";
import {responseField} from "../../../../base.graphql";

export const wardGqlFields = `
id
uniqueId
name
code
`;


export const ALL_WARDS_BY_DISTRICT = gql`
query GetAllWards($districtUniqueId: String) {
  getAllWards(districtUniqueId: $districtUniqueId) {
      response {
        ${responseField}
      }
      data {
        ${wardGqlFields}
      }
    }
  }
`
